(function (Lfl, $, undefined) {
    /**
     * @memberOf Lfl
     */
    Lfl.Tooltips = Lfl.Tooltips || {};

    (function (Tooltips, $, undefined) {
        if (Lfl.Files.isLoadedAlready(Lfl.Tooltips, 'EnablerForDisabled')) {
            return;
        }

        /*
         |==============================================================================================================
         | Documentation
         |==============================================================================================================
         */

        /**
         * Object that allows the enabling of tooltips on disabled buttons on page.
         *
         * @memberOf Lfl.Tooltips
         */
        Lfl.Tooltips.EnablerForDisabled = Tooltips.EnablerForDisabled || {};

        (function (EnablerForDisabled, $, undefined) {
            /*
             |==========================================================================================================
             | Object definition 
             |==========================================================================================================
             */

            /*
             |----------------------------------------------------------------------------------------------------------
             | Public methods
             |----------------------------------------------------------------------------------------------------------
             */

            /**
             * @memberOf Lfl.Tooltips.EnablerForDisabled
             */
            EnablerForDisabled.enableBootstrapTooltipForDisabled = function (id) {
                FunctionsCaller.register(function ($) {
                    $(function () {
                        var button = $('#' + id + '[data-toggle="tooltip"]');

                        if (button.hasClass('disabled')) {
                            button.css('pointer-events', 'all');
                            button.css('cursor', 'not-allowed');
                        }

                        button.click(function (e) {
                            e.preventDefault();
                        });
                    })
                });
            }

        }(Tooltips.EnablerForDisabled, jQuery));
    }(Lfl.Tooltips, jQuery));
}(window.Lfl = window.Lfl || {}, jQuery));

/*
 |-------------------------------------------------------------------------------------------------------------------
 | Discarded
 |-------------------------------------------------------------------------------------------------------------------
 | Currently not working (offset returns incorrect data), might be useful later.
 */
///**
// * Enables Bootstrap tooltip for elements that have the "disabled" property or ".disabled" class.
// */
//function enableTooltipForDisabled(elementId) {
//    alert('Does not work correctly ATM.');
//    FunctionsCaller.registerAndRunImmeaditely(function ($) {
//            $('#' + elementId).after(function (e) {
//                var wrapper = $("<div>");
//                var i = $(this);
//
//                wrapper.css({
//                    height: i.outerHeight(),
//                    width: i.outerWidth(),
//                    position: "absolute"
//                });
//
//                var offset = i.offset();
//
//                wrapper.css($('#' + elementId).offset());
//                wrapper.attr("title", i.attr("title"));
//                wrapper.tooltip();
//                return wrapper;
//            });
//        }
//    );
//}

